export const EMPTY_SERVICE_FORM = {
  title_ar: "",
  title_en: "",
  description_ar: "",
  description_en: "",
};
